var _PdfCharacterString = /** @class */ (function () {
    function _PdfCharacterString(identification, stringValue) {
        this._identification = identification;
        this._stringValue = stringValue;
    }
    _PdfCharacterString.prototype._toString = function () {
        return ('CHARACTER STRING { ' +
            ("identification " + this._identification._toString() + " ") +
            ("dataValue " + Array.from(this._stringValue).map(function (byte) { return byte.toString(16); }).join('') + " ") +
            '}');
    };
    _PdfCharacterString.prototype._toJson = function () {
        return {
            identification: this._identification._toJson(),
            dataValue: Array.from(this._stringValue).map(function (byte) { return byte.toString(16); }).join('')
        };
    };
    return _PdfCharacterString;
}());
export { _PdfCharacterString };
